import { useTranslation } from '@mint-lib/i18n';
import { Illustration } from '@mint-lib/illustrations';
import { typographyVariants } from '@mint-lib/tw-components';

const NoResult = () => {
  const { t } = useTranslation('@myn/approval_v2');
  return (
    <div className="flex flex-col items-center gap-2">
      <div className="h-40 w-40">
        <Illustration
          className="size-40"
          aria-label="No plans found"
          component="IllustrationNoResults"
        />
      </div>
      <div className="flex flex-col gap-2">
        <h4 className={typographyVariants({ variant: 'h4' })}>
          {t('No results')}
        </h4>
        <span
          className={typographyVariants({
            variant: 'bodyShort01',
            color: 'secondary',
          })}
        >
          {t('Try for other filter options')}
        </span>
      </div>
    </div>
  );
};

export default NoResult;
